// extracted by mini-css-extract-plugin
export default {"triangle":"_2LO54","outer":"_31l0T","inner":"_3sppA","right":"_2v0D7","left":"_2H5pR"};